/**
 *
 * Asynchronously loads the component for ResetPasswordPage
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
